import { refreshModelsEcrRequest, fetchModelsEcrRequest } from 'api/Exec/api';
import { ModelEcr } from 'api/Exec/types';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';

import { message } from 'antd';
import { useCallback, useEffect, useState } from 'react';

const useModelEcrs = () => {
  const [ isLoading, setIsLoading ] = useState<boolean>(true);
  const [ dockerImages, setDockerImages ] = useState<ModelEcr[]>([]);

  const fetchDockerImages = useCallback((refresh: boolean, abortController?: AbortController) => {
    setIsLoading(true);
    const callback = refresh ? refreshModelsEcrRequest : fetchModelsEcrRequest;
    callback(abortController)
      .then((response) => {
        setDockerImages(response.data);
      })
      .catch((reason) => {
        if (!abortController?.signal.aborted) {
          message.error(getErrorFromPromiseReason(reason));
        }
      })
      .finally(() => {
        if (!abortController?.signal.aborted) {
          setIsLoading(false);
        }
      });
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    fetchDockerImages(true, abortController);

    return () => {
      abortController.abort();
    };
  }, [ fetchDockerImages ]);

  return { fetchDockerImages, dockerImages, isLoading };
};

export default useModelEcrs;
